import type { Language } from '@/i18n/translations';

export function buildLanguageLayer(lang: Language): string {
  return lang === 'sv'
    ? 'Svara alltid på svenska med naturlig, professionell ton.'
    : 'Always respond in English with a natural, professional tone.';
}
